import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { toast } from "react-toastify";

const EmployeeKpiModal = ({ show, onHide, finData, budgetName, finYear1 }) => {

    const [finDtlData, setFinDtlData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [supName, setSupName] = useState('');

    // 🔹 Load Data when modal opens
    useEffect(() => {

        if (!show || !finData) return;

        const loadData = async () => {

            setLoading(true);

            try {

                setFinDtlData(finData);

            } catch (err) {
                console.error(err);
                toast.error("Error loading KPI details");
            } finally {
                setLoading(false);
            }
        };

        loadData();

    }, [finData]);

    const formatAmount = (amount) =>
        Number(amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

    const totalAmount = finDtlData.reduce(
        (total, d) => total + Number(d.amount || 0),
        0
    );

    return (

        // <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal show={show} onHide={onHide} centered dialogClassName="modal-xxl">
            <Modal.Header closeButton>
                <Modal.Title>
                    <div>
                        <div style={{ fontSize: "18px", fontWeight: "600", marginBottom: '5px' }}> Detailed Budget View
                           
                        </div>
                        <div style={{ fontSize: "15px", fontWeight: "600" }}> Budget Name :  {budgetName} - {finYear1} - {Number(finYear1) + 1}
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {/* 🔹 Loader */}
                {loading ? (
                    <div className="text-center p-4">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <>

                        {/* 🔹 Table */}
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {/* <div style={{ minHeight: '350px', overflowY: "auto" }} className="table-wrapper"> */}
                            <table style={{ maxHeight: '38px' }} className="table table-bordered table-hover responsive-table-modal scty-custom-table">
                            {/* <table style={{ maxHeight: '38px' }} className="responsive-table-modal scty-custom-table"> */}

                                <thead style={{ position: "sticky", top: 0, background: "#fff" }}>
                                    <tr>
                                        <th style={{ width: "7%" }}>Section</th>
                                        <th style={{ width: "10%" }}>Date</th>
                                        <th style={{ width: "8%" }}>Vchr No</th>
                                        <th style={{ width: "15%" }}>Sub-Budget Name</th>
                                        <th style={{ width: "15%" }}>Cash/Bank Name</th>
                                        <th style={{ width: "15%" }}>Ledger Account</th>
                                        <th style={{ width: "22%" }}>Narration</th>
                                        <th style={{ width: "15%" }}>Paid To</th>
                                        <th style={{ width: "12%", textAlign: "right" }}>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {finDtlData.length === 0 && (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}

                                    {finDtlData.map((d, i) => (
                                        <tr key={i} >
                                            <td>{d.sec_prefix}</td>
                                            <td>{d.vchr_date}</td>
                                            <td>{d.vchr_no}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.sub_bgt_name}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.cb_title}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.cb_acct_name}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.narration}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.paid_to}</td>
                                            <td style={{ textAlign: "right", fontWeight: "bold" }}> {formatAmount(d.amount)} </td>
                                        </tr>
                                    ))}

                                </tbody>

                                    <tfoot>
                                        <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                                            <td colSpan="8" style={{ textAlign: "right", fontSize: "18px" }}>
                                                Total:
                                            </td>
                                            <td style={{ textAlign: "right", fontSize: "18px" }}>
                                                {formatAmount(totalAmount)} &nbsp;
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>

                            </table>
                        </div>

                    </>
                )}

            </Modal.Body>

        </Modal>
    );
};

export default EmployeeKpiModal;
